import { useState, useEffect, useCallback, useRef } from "react";

import { PaymentMethod } from "../bitmaker/schemas/Billing/Payment";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);
  const [fetchPaymentMethodsError, setFetchPaymentMethodsError] = useState<
    string | null
  >(null);

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchPaymentMethods = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingPaymentMethods(true);
    setFetchPaymentMethodsError(null);

    BitmakerAPIClient.get(
      "/billing/settings/payment-methods",
      {},
      (response) => {
        if (!isMountedRef.current) return;

        const { isError, message } = handleAPIError(response);

        if (isError) {
          console.error("Error fetching payment methods:", message);
          setFetchPaymentMethodsError(
            "Error fetching payment methods. Please try again.",
          );
          setLoadingPaymentMethods(false);
          return;
        }

        const data = Array.isArray(response.data) ? response.data : [];
        setPaymentMethods(data);

        setLoadingPaymentMethods(false);
      },
    );
  }, [handleAPIError]);

  useEffect(() => {
    fetchPaymentMethods();
  }, [fetchPaymentMethods]);

  return {
    paymentMethods,
    loadingPaymentMethods,
    fetchPaymentMethodsError,
    refetchPaymentMethods: fetchPaymentMethods,
  };
};
